import DelayDaysInput from '@/common/components/DelayDaysInput/DelayDaysInput'
import ReasonField from '@/common/components/ReasonField/ReasonField'
import RefundHoldModeSelector from '@/common/components/RefundHoldModeSelector/RefundHoldModeSelector'
import { refundHoldModeValues } from '@/common/constants'
import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import * as Styles from './styles'

const PutRefundOnHoldConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const hasReasonError = errors.some(e => e.type === errorTypes.actionReasonEmpty)
  const hasDelayDaysError = errors.some(e => e.type === errorTypes.actionDelayDaysInvalid)

  const isDelayMode = config.refund_hold_mode === refundHoldModeValues.delayByDays

  const handleChangeMode = e => {
    const mode = e.target.value

    if (mode === refundHoldModeValues.delayByDays) {
      onChangeConfig({ refund_hold_mode: mode, refund_hold_delay_days: config.refund_hold_delay_days ?? '' })
    } else {
      onChangeConfig({ refund_hold_mode: mode, refund_hold_delay_days: null })
    }
  }

  const handleChangeDelayDays = e => onChangeConfig({ refund_hold_delay_days: e.target.value })

  const handleChangeReason = e => onChangeConfig({ hold_reason: e.target.value })

  return (
    <Styles.Container>
      <RefundHoldModeSelector value={config.refund_hold_mode} onChange={handleChangeMode} />
      {isDelayMode && (
        <DelayDaysInput
          value={config.refund_hold_delay_days}
          onChange={handleChangeDelayDays}
          disabled={disabled}
          error={hasDelayDaysError}
        />
      )}
      <ReasonField
        value={config.hold_reason}
        onChange={handleChangeReason}
        disabled={disabled}
        error={hasReasonError}
      />
    </Styles.Container>
  )
}

export default PutRefundOnHoldConfig
